import {use} from 'react';

import {AuditImageSelectionContext} from '../contexts/AuditImageSelectionContext';
import {TAuditImageSelectionContext} from '../types/TAuditImageSelectionContext';

export const useAuditImageSelectionContext = (): TAuditImageSelectionContext =>
  use(AuditImageSelectionContext);
